import React from "react"
import createTemplate from "../../create-template"

import { useComponents } from "../../components"

function RegentThankYou({ styles, editing, ...props }) {
  const Elements = useComponents()

  return (
    <Elements.LandingPage
      styles={styles}
      {...props}
      style={styles.forElement("page")}
    >
      <div className="formkit-container">
        <div
          className="formkit-sidebar"
          style={styles.forElement("form_background")}
        >
          <header>
            <Elements.Content
              className="formkit-preheading"
              name="preheader"
              defaults={{
                content: "New material"
              }}
            />
            <Elements.Heading
              className="formkit-heading-primary"
              name="header"
              defaults={{
                content: "Thank you for signing up"
              }}
            />
          </header>
          <div className="formkit-main">
            <Elements.Region className="formkit-content" name="content">
              <Elements.Content
                defaults={{
                  content:
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed a aliquet justo. Suspendisse massa."
                }}
              />
            </Elements.Region>
            <Elements.BuiltWith background="form_background" />
          </div>
        </div>
        <div
          style={{
            backgroundColor: styles.forElement("video_background")
              .backgroundColor,
            position: editing ? "absolute" : null
          }}
          className="formkit-video-container"
        >
          <div
            style={styles.forElement("video_background")}
            className="formkit-background-image"
          />
          <Elements.Video name="video" className="formkit-video" />
        </div>
      </div>
    </Elements.LandingPage>
  )
}

RegentThankYou.style = "landing_page"
RegentThankYou.categories = ["Video"]
RegentThankYou.thumbnail = ""
RegentThankYou.preview = "https://demo.ck.page/regent"
RegentThankYou.fields = [
  {
    name: "first_name",
    label: "Full name"
  },
  {
    name: "email_address",
    label: "E-mail"
  }
]

export default createTemplate(RegentThankYou, { name: "RegentThankYou" })
